import * as React from 'react';
import { connect } from 'react-redux';
import Geocode from "react-geocode";
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import { SA_COUNTRY_ID_NUMBER } from '../../../../constants/internationalization';
import { handleNextStep, setQuoteData, saveAddress } from '../../../../actions/salesActions';
import './Address.css';

const geoCodeApiKey = "AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8";

class AddressCreate extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            addressText: "",
            addressSelect: "",
            addressDetail: { province: null, city: null, suburb: null, postalCode: null, formatted: null },
            lat: this.props.sales.lat,
            lng: this.props.sales.lon,
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);

        this.mapReady = this.mapReady.bind(this);
        this.mapClick = this.mapClick.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleAddressSelect = this.handleAddressSelect.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Geocode.setApiKey(geoCodeApiKey);
        this.checkSubmit();
    }

    checkSubmit() {
        let valid = (this.state.addressSelect?.length > 0 && this.state.lat !== 0 && this.state.lng !== 0);
        this.setState({ nextDisabled: !valid });
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(setQuoteData({
                address: this.state.addressSelect,
                addressDetail: this.state.addressDetail,
                lat: this.state.lat,
                lon: this.state.lng,
            }));
            let addressId = await this.props.dispatchAction(saveAddress(this.state.addressSelect, this.state.lat, this.state.lng, this.state.addressDetail));
            if (addressId !== null) {
                this.props.dispatchAction(setQuoteData({ addressId: addressId, address: this.state.addressSelect, addressDetail: this.state.addressDetail }));
                await this.props.dispatchAction(handleNextStep());
            }
        }
    }

    async mapReady(mapProps, map) {
        let lat: any = map.center.lat();
        let lng: any = map.center.lng();

        if (window.navigator && window.navigator.geolocation) {
            let location = window.navigator.geolocation;
            if (location) {
                location.getCurrentPosition((position) => {
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;
                    this.setLocation(lat, lng, "");
                });
            }
        }
    }

    async mapClick(mapProps, map, clickEvent) {
        let lat = clickEvent.latLng.toJSON().lat
        let lng = clickEvent.latLng.toJSON().lng
        this.setLocation(lat, lng);
    }

    async setLocation(lat, lng, addressSelection: any = null) {
        let address, suburb, city, state, postal_code;

        await Geocode.fromLatLng(lat, lng).then(
            async (response) => {
                address = response.results[0].formatted_address;
                for (let i = 0; i < response.results[0].address_components.length; i++) {
                    for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
                        switch (response.results[0].address_components[i].types[j]) {
                            case "sublocality":
                                suburb = response.results[0].address_components[i].long_name.toUpperCase();
                                break;
                            case "administrative_area_level_1":
                                state = response.results[0].address_components[i].long_name.toUpperCase();
                                break;
                            case "locality":
                                city = response.results[0].address_components[i].long_name.toUpperCase();
                                break;
                            case "postal_code":
                                postal_code = response.results[0].address_components[i].long_name.toUpperCase();
                                break;
                        }
                    }
                }
            }
        );
        if (addressSelection !== null) {
            address = addressSelection;
        }

        this.setState({ lat: lat, lng: lng, addressText: address, addressSelect: address, addressDetail: { province: state, city: city, suburb: suburb, postalCode: postal_code, formatted: address } },
            () => this.checkSubmit()
        );
    }

    handleAddressChange(address) {
        this.setState({ addressText: address, addressSelect: "" },
            () => this.checkSubmit()
        );
    };

    handleAddressSelect(address) {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                this.setLocation(latLng.lat, latLng.lng, address);
            })
            .catch();
    };

    public render() {
        const countryFilter = (this.props.profile.countryId === SA_COUNTRY_ID_NUMBER) ? "ZA" : "NA"

        return (
            <div className="container create-address-component">
                <div className="step-instructions text-center mt-4">
                    Type in your address here:
                </div>

                <div className="mt-4">
                    <label className={"inline-label mb-6px " + (this.state.addressText === "" ? " hidden" : "")}>Physical address</label>

                    <PlacesAutocomplete
                        value={this.state.addressText}
                        onChange={this.handleAddressChange}
                        onSelect={this.handleAddressSelect}
                        searchOptions={{ componentRestrictions: { country: countryFilter } }}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div className="position-relative">
                                <input
                                    {...getInputProps({
                                        placeholder: "Physical address",
                                        className: " ssp-autocomplete-searchbox autocomplete-searchbox-bordered",
                                    })}
                                />
                                <div className={(suggestions.length > 0 ? "ssp-autocomplete-dropdown-container" : "d-none")}>
                                    {loading && <div className="ssp-autocomplete-loading">Loading...</div>}
                                    {suggestions.map(suggestion => {
                                        const className = "ssp-autocomplete-suggestion-item";
                                        return (
                                            <>
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                    })}
                                                >
                                                    <span className="ssp-autocomplete-suggestion-actual">{suggestion.description}</span>
                                                </div>
                                                <div className="ssp-autocomplete-hr-container">
                                                    <hr className="ssp-autocomplete-hr-divider" />
                                                </div>
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                </div>

                <div className={"ssp-googlemap-holder" + (this.state.addressSelect === "" ? " hidden" : "")}>
                    <Map google={this.props.google}
                        centerAroundCurrentLocation
                        center={{ lat: this.state.lat, lng: this.state.lng }}
                        onReady={this.mapReady}
                        onClick={this.mapClick}
                        containerStyle={{
                            position: "relative",
                            overflow: "hidden",
                            width: "100%",
                            height: "100%",
                            borderRadius: "8px"
                        }}
                        // @ts-ignore
                        streetViewControl={false}
                        fullscreenControl={false}
                        mapTypeControl={false}
                    >
                        <Marker
                            // @ts-ignore
                            position={{ lat: this.state.lat, lng: this.state.lng }}
                            draggable={false}
                            
                            title="Physical address"
                        />
                    </Map>
                </div>

                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(AddressCreate);

export default GoogleApiWrapper({ apiKey: geoCodeApiKey })(connector);